import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center watercolor-wash px-5 safe-top safe-bottom">
      <div className="w-full max-w-md rounded-2xl bg-ivory-50 p-8 text-center shadow-xl ring-1 ring-ivory-400/50" data-testid="payment-cancel">
        <h1 className="font-display text-2xl text-ink">No rush — the door stays open.</h1>
        <p className="mt-2 text-sm text-ink-soft">Your checkout was cancelled and nothing was charged. Whenever you're ready, the full book will be here.</p>
        <Link to="/get-the-book" data-testid="cancel-back" className="debossed-btn mt-6 inline-flex w-full items-center justify-center rounded-full px-6 py-3 font-display text-ink">Return to the offers</Link>
        <Link to="/" className="mt-3 inline-block text-sm text-ink-muted hover:text-gold-deep">Back to the book</Link>
      </div>
    </div>
  );
}
